import { classNamesFor } from '../../../utils/classNames';

const factory = classNamesFor('Label');

export const labelClassNames = {
  root: factory.root(),
  label: factory.element('label'),
  asterisk: factory.element('asterisk'),
  tooltip: factory.element('tooltip'),
  disabled: factory.attribute('disabled'),
};
